import React from "react";

const ShippingPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 px-6 text-gray-700 leading-relaxed">
      <h1 className="text-3xl font-bold mb-6 text-black">Shipping Policy</h1>

      <p className="mb-6">
        Last updated: <strong>26 jan 2026</strong>
      </p>

      <p className="mb-6">
        This Shipping Policy describes how orders are processed, shipped, and
        delivered after successful payment. By placing an order with us, you
        agree to the shipping terms outlined below.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        1. Order Processing
      </h2>
      <p>
        Orders are processed after payment confirmation. Processing time may
        vary depending on product availability, order quantity, and delivery
        location.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        2. Shipping & Delivery Timeline
      </h2>
      <p>
        Estimated delivery timelines are shared at the time of order confirmation.
        Delivery timelines may vary due to factors such as distance, weather,
        traffic conditions, or other operational constraints.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        3. Delivery Charges
      </h2>
      <p>
        Delivery or transportation charges, if applicable, are communicated
        before order confirmation and are included in the final payable amount
        unless stated otherwise.
      </p>
      <p className="mt-2">
        <strong>Delivery charges are non-refundable</strong>, except in cases
        where the order is not delivered at all.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        4. Shipping Coverage
      </h2>
      <p>
        We currently deliver within designated serviceable areas. Delivery
        availability depends on location accessibility and logistical feasibility.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        5. Delivery Conditions
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          The customer must ensure proper access to the delivery location for
          unloading.
        </li>
        <li>
          Once the product is delivered and unloaded from the vehicle, the
          delivery is considered complete.
        </li>
        <li>
          Delays caused by incorrect address details or customer unavailability
          are not our responsibility.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        6. Delays & Unforeseen Events
      </h2>
      <p>
        Delivery timelines may be affected by unforeseen circumstances such as
        natural disasters, strikes, vehicle breakdowns, or government
        restrictions. Such delays do not qualify for automatic refunds.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        7. Shipment Tracking & Communication
      </h2>
      <p>
        Customers may receive delivery updates via phone calls, SMS, WhatsApp,
        or RCS messages based on the contact details provided at the time of
        order placement.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        8. Compliance with Payment Gateways
      </h2>
      <p>
        This Shipping Policy is aligned with standard payment gateway and
        regulatory requirements. Any disputes related to shipping will be
        handled in accordance with this policy.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        9. Policy Updates
      </h2>
      <p>
        We reserve the right to modify this Shipping Policy at any time. Updates
        will be posted on this page with a revised date.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        10. Contact Us
      </h2>
      <p>
        For questions related to shipping or delivery, please contact us:
      </p>
      <p className="mt-2">
        <strong>Business Name:</strong> __________ <br />
        <strong>Phone:</strong> __________ <br />
        <strong>Email:</strong> __________
      </p>
    </div>
  );
};

export default ShippingPolicy;
